import { render, staticRenderFns } from "./PilarCard.vue?vue&type=template&id=5f4bdcc0&scoped=true"
import script from "./PilarCard.js?vue&type=script&lang=js&external"
export * from "./PilarCard.js?vue&type=script&lang=js&external"
import style0 from "./PilarCard.scss?vue&type=style&index=0&id=5f4bdcc0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4bdcc0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HcmImage: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/node_modules/@hotmart-org-ca/cosmos-mkt/components/Elements/HcmImage/index.vue').default,HcmCard: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/node_modules/@hotmart-org-ca/cosmos-mkt/components/Elements/HcmCard/index.vue').default})
